module.exports = __webpack_public_path__ + "img/trainer-snip3.282a9e2b.jpg";